import { SectionRowViewModel } from './SectionRowViewModel';
import { VariantTypeUtils } from '../../../../../../../../../utils/variant-type-utils';
import { memoize } from '../../../../../../../../shared/decorators/memoize';

export class SectionRowViewModelBanded extends SectionRowViewModel {
  @memoize
  public getQuantityString(): string {
    if (this.variantLineItemMode) {
      const isPreRoll = VariantTypeUtils.isPreRollType(this.rowVariants?.firstOrNull()?.variantType);
      if (isPreRoll) return `${this.getQuantity()} pk`;
    }
    return this.getQuantity().toString();
  }
}
